import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Stack, IconButton, Divider, Paper } from "@mui/material";

import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import Offline from "./Offline";
import TasksWidget from "./TasksWidget";
import ThemePopover from "./ThemePopover";
import ProfilePopover from "./ProfilePopover";

export default function Navbar({ onOpenSidebar }) {
  const navigate = useNavigate();
  const back = () => navigate(-1);

  const { userRoles } = useSelector((state) => state.auth);

  const hasRole = userRoles.length > 0;

  return (
    <Box
      height={64}
      component="header"
      sx={{
        top: 0,
        zIndex: 1000,
        position: "sticky",
      }}
    >
      <Offline />
      <Paper
        sx={{
          height: "100%",
          bgcolor: "primary.main",
          borderRadius: 0
        }}
      >
        <Stack
          p={1}
          height="100%"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" columnGap={1}>
            <IconButton
              size="small"
              onClick={onOpenSidebar}
              sx={{ color: "#fff", bgcolor: "action.hover" }}
            >
              <MenuRoundedIcon fontSize="small" color="inherit" />
            </IconButton>
            <Divider
              orientation="vertical"
              sx={{ height: 24, display: { xs: "none", md: "flex" } }}
            />
            <img
              width={48}
              height={48}
              src="logo.svg"
              style={{ objectFit: "contain" }}
            />
          </Stack>
          <Stack direction="row-reverse" alignItems="center" columnGap={1}>
            <IconButton
              size="small"
              onClick={back}
              sx={{ color: "#fff", bgcolor: "action.hover" }}
            >
              <ArrowBackIosNewRoundedIcon fontSize="small" color="inherit" />
            </IconButton>
            <ProfilePopover />
            <ThemePopover />
            {hasRole && <TasksWidget title="کارتابل" />}
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
